/**
 *
 * FiltersContainer
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

import { Tooltip } from "antd"
import { uniq, slice, truncate } from "lodash"
import "./index.less"
import broomSvg from "../../images/broom.svg"
import { CloseOutlined } from "@ant-design/icons"

class FiltersContainer extends React.Component {
  removeAllFilters = () => {

    this.props.removeFilter("delete-all")
                  .then(() => {
                    if (this.props.getDivisions) {
                      this.props.getDivisions();
                    }
                  });
  }

  render() {
    const tooltipText = () => {
      return (
        <div className="tooltiptext">
          {slice(this.props.filters, 0, this.props.filters.length - 3).map(
            (item, i) => {
              return (
                <span key={i}>
                  {i + 1}. {item}
                </span>
              )
            }
          )}
        </div>
      )
    }

    return (
      <div className="filtersContainer">
        <div style={{ display: "flex", alignItems: "center" }}>
          {!!this.props.filters.length && (
            <Tooltip placement="top" title="Limpiar filtros">
              <img
                src={broomSvg}
                style={{ cursor: "pointer" }}
                onClick={this.removeAllFilters}
              />
            </Tooltip>
          )}
        </div>
        {uniq(this.props.filters).length > 3 && (
          <Tooltip placement="top" title={tooltipText}>
            <div className="filter" style={{ cursor: "pointer" }}>
              + {this.props.filters.length - 3} filtros
            </div>
          </Tooltip>
        )}
        {slice(uniq(this.props.filters), -3).map((item, index) => {
          return (
            <div key={index} className="filter">
              {truncate(item, { length: 30 })}
              <CloseOutlined
              onClick={() => {
                this.props.removeFilter(item)
                  .then(() => {
                    if (this.props.getDivisions) {
                      this.props.getDivisions();
                    }
                  });
              }}
              style={{ lineHeight: "20px", paddingLeft: 5 }}
            />
            </div>
          )
        })}
      </div>
    )
  }
}

FiltersContainer.propTypes = {}

export default FiltersContainer
